module.exports = __webpack_public_path__ + "static/media/Icons_IS-duplicate.837bf281.svg";